import angular from 'angular';
import template from './phoneNumber.html';
import PhoneNumberComponent from './phoneNumber.component';

const phoneNumberConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('phoneNumber', {
		title:      'Phone Number',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   new PhoneNumberComponent(),
		icon: 'fa fa-phone-square',
		views: [
			{
				name:     'Display',
				template: 'kform/components/phoneNumber/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/textfield/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app').config(phoneNumberConfig);
